import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import MultiStepGameForm from "../MultiStepGameForm/MultiStepGameForm";
import AdminHeader from "../AdminHeader";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import "./CreateOrUpdateGame.scss";

const CreateOrUpdateGame = () => {
  const { gameId } = useParams();
  const navigate = useNavigate();
  const [game, setGame] = useState(null);
  const [loading, setLoading] = useState(!!gameId); // Only show loading if editing
  const [error, setError] = useState("");
  const {
    client,
    gameAccess,
    getAuthHeaders,
    handleAuthError,
    requireAuth,
    logout,
  } =
    useAdminAuth();

  const isEditMode = !!gameId;

  // Ensure user is authenticated
  useEffect(() => {
    if (!requireAuth()) return;
  }, [requireAuth]);

  useEffect(() => {
    if (isEditMode && client) {
      fetchGame();
    }
  }, [gameId, isEditMode, client]);

  const fetchGame = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `/api/games?admin=true`,
        getAuthHeaders()
      );

      // Parse gameId as integer for comparison
      const gameIdInt = parseInt(gameId, 10);
      const foundGame = response.data.find((g) => g.id === gameIdInt);

      if (!foundGame) {
        setError("Game not found");
        return;
      }

      setGame(foundGame);
    } catch (error) {
      if (!handleAuthError(error)) {
        setError("Failed to fetch game");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSuccess = () => {
    navigate("/admin/dashboard");
  };

  const handleCancel = () => {
    navigate("/admin/dashboard");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  if (loading) {
    return (
      <div className="admin-dashboard">
        <AdminHeader
          client={client}
          onGoHome={handleGoHome}
          onLogout={logout}
        />
        <div className="admin-dashboard__content">
          <div className="loading">Loading game...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-dashboard">
        <AdminHeader
          client={client}
          onGoHome={handleGoHome}
          onLogout={logout}
        />
        <div className="admin-dashboard__content">
          <div className="error-message">
            {error}
            <button className="btn btn-outline" onClick={handleCancel}>
              ← Back to Dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <AdminHeader client={client} onGoHome={handleGoHome} onLogout={logout} />

      <div className="admin-dashboard__content create-or-update-game">
        <MultiStepGameForm
          game={game}
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          getAuthHeaders={getAuthHeaders}
          client={client}
          gameAccess={gameAccess}
        />
      </div>
    </div>
  );
};

export default CreateOrUpdateGame;
